let module = angular.module('jszip', []);
module.service('JSZip', function () {
  this.init = () => {
    return new Promise((resolve, reject) => {
      require.ensure([], () => {
        var jszip = require('jszip');
        resolve(jszip);
      });
    });
  };
});
export default module;



// WEBPACK FOOTER //
// ./app/services/jszip.js